module.exports = __webpack_public_path__ + "static/media/ui-elements-buttons-left-menu-off.c62b384d.svg";